export default "__VITE_ASSET__CI$2x6q5__"